import { BASE_URL } from "./variables";

export const login = async ({ username, password }) => {
  try {
    console.log('login: payload=', { username });
    const res = await fetch(`${BASE_URL.replace('/fms', '')}/authentication/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ username, password })
    });

    const text = await res.text();
    let data = null;
    try { data = text ? JSON.parse(text) : null; } catch (e) { data = text; }

    if (!res.ok) {
      console.error(`login: HTTP ${res.status}`, text);
      throw new Error(`login failed: ${res.status} ${res.statusText}`);
    }

    console.log('login: response=', data);
    return data;
  } catch (error) {
    console.error('Error in login:', error);
    throw error;
  }
};

export default login;
